export function usePermission(key: string) {
  const getPermissions = () => {
    try {
      const stored = localStorage.getItem("permissions");
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error("Error loading permissions from localStorage:", error);
    }
    return {};
  };

  const permissions = getPermissions();
  const perm = permissions?.[key];
  
  if (perm && typeof perm === 'object') {
    return {
      canIndex: perm.index === true,
      canStore: perm.store === true,
      canUpdate: perm.update === true,
      canDelete: perm.delete === true,
    };
  }
  
  return {
    canIndex: false,
    canStore: false,
    canUpdate: false,
    canDelete: false,
  };
}